import { updateCancellationReasonRequest } from "../../data/cancellationReasonApi";
import { validateCancellationReasonPayload } from "../validator/validateCancellationReasonPayload";

export async function updateCancellationReasonUseCase(payload) {
  if (!Number.isInteger(Number(payload?.id)) || Number(payload.id) <= 0) {
    throw new Error("El motivo de cancelacion no es valido.");
  }

  const error = validateCancellationReasonPayload(payload);

  if (error) {
    throw new Error(error);
  }

  return await updateCancellationReasonRequest(payload);
}
